import { BiQueryResult } from '@euler/model/bi/result';
import { BiKpiGroupViz, BiVizSpec, BiVizType } from '@euler/model/bi/viz';
import { biTableOfFunnel } from './biFunnelTable';
import { biTableOfKpiGroup } from './biKpiGroupTable';
import {
  BiTableModel,
  biTableOfChart,
  biTableOfTableViz,
} from './biResultTable';

/**
 * The table behind any viz, as its result table shows it: a table's own
 * columns, a chart's rows, a funnel's stages, a KPI's numbers (a single KPI
 * as a group of one). Null when the viz names a column the result lacks.
 */
export function biTableOfViz(
  viz: BiVizSpec,
  result: BiQueryResult,
): BiTableModel | null {
  switch (viz.type) {
    case BiVizType.Table:
      return biTableOfTableViz(viz, result);
    case BiVizType.Funnel:
      return biTableOfFunnel(viz, result);
    case BiVizType.KpiGroup:
      return biTableOfKpiGroup(viz, result);
    case BiVizType.Kpi: {
      const group: BiKpiGroupViz = {
        type: BiVizType.KpiGroup,
        items: [{ value: viz.value, format: viz.format }],
      };
      return biTableOfKpiGroup(group, result);
    }
    default:
      return biTableOfChart(viz, result);
  }
}
